<template>
<div :class=" search_status ? 'index page_fenlei page_map page_iteminfo page_art page_limit': 'index page_fenlei page_art page_map page_iteminfo'">
    <!-- 内容区 -->
    <div class="">
        <div class="reocrd_item_tr" >
            <div style="width:5em;">扫码次数</div>
            <div style="flex:1;">扫码详情</div>
        </div>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData" :immediate-check="false">
                <div class="reocrd_item" v-for="(item,index) in dataList" :key="item.id">
                    <div class="num">{{ index+1 }}</div>
                    <div class="time">{{ item.created_at }}</div>
                    <div class="place">{{ item.address }}</div>
                </div>
                
            </van-list>
        </van-pull-refresh>
    </div>
    <!-- 遮罩层 -->
    <van-overlay :show="search_status" class="overlay" />
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import PageSearch from "../../../component/search/Index.vue";
import Vue from 'vue';
import Bridge from '../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    // name: "map-index",
    data() {
        return {
            publicPath: process.env.BASE_URL,
            token: null,
            code: this.$route.query.code,
            finished: false,
            dataList: [],
            page: 1,
            size: 10,
            loading: false,
            refreshing: false,
            shareConfig: null // 分享的相关配置
        };
    },
    components: {
        PageSearch
    },
    created: function () {
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '查询记录'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                    'notCallLogin': 1,
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                } else {
                    this.token = ''
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
        } else {
            // 获取列表
			this.token = this.$store.getters.token
			// 调起 获取微信分享参数函数 -- 弃用,改成统一配置的
            // this.getShareData()
            
        }
        this.onRefresh();
    },
    methods: {
        onRefresh() {
            // 清空列表数据
            this.finished = false;

            // 重新加载数据
            // 将 loading 设置为 true，表示处于加载状态
            this.loading = true;
            this.page = 1
            this.getData();
        },
        // 获取列表
        getData() {
            var params = {
                code: this.code,
                token: this.token,
                page: this.page,
                size: this.size
            }
            console.log('params', params)
            this.$api.blockchain.scancode(params).then(res => {
                if (res.code == 200) {
                    var list = res.result;
                    if (this.page == 1) {
                        this.dataList = list
                        // 推荐匠人 按四个一组实现轮播效果
                    } else {
                        var old = this.dataList
                        for (let i = 0; i < list.length; i++) {
                            old.push(list[i])
                        }
                        this.dataList = old
                    }
                    if (list.length == 0) {
                        // 数据全部加载完
                        this.finished = true
                        this.refreshing = false
                        return;
                    }
                } else {
                    this.finished = true
                    this.$toast(res.message)
                }
                this.page++;
                this.refreshing = false
                this.loading = false;
            })
        },
        // 确定
        submit() {
            this.search_status = false
            this.onRefresh()
        },
        // 获取分享参数 -- 用于配微信分享
        getShareData() {
            const url = location.href.split('#')[0];
            console.log('url', url)
            this.$api.index.commonShare({
                url: url
            }).then(res => {
                if (res.code == 200) {
                    this.shareConfig = res.result
                    // console.log('this.shareConfig', this.shareConfig)
                    // console.log('this.$route', this.$route)
                    this.shareFun()
                }
            })
        },
        // 分享
        shareFun() {
            var that = this
            wx.config({
                debug: that.shareConfig.debug,
                beta: that.shareConfig.beta,
                jsApiList: that.shareConfig.jsApiList,
                appId: that.shareConfig.appId,
                nonceStr: that.shareConfig.nonceStr, // 随机串
                timestamp: parseInt(that.shareConfig.timestamp), // 时间戳
                signature: that.shareConfig.signature // 签名
            });
            // 分享
            wx.ready(function () {
                const url = location.href.split('#')[0];
                var shareData = {
                    title: '非遗匠人', // 分享标题
                    desc: '时代记忆', // 分享描述
                    link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: that.$publicData.domain + that.$publicData.logo, // 分享图标
                    success: function () {
                        // 用户确认分享后执行的回调函数
                        // alert('成功')
                    },
                    cancel: function (e) {
                        // alert(e)
                        // 用户取消分享后执行的回调函数
                    }
                }
                wx.updateAppMessageShareData(shareData);
                wx.updateTimelineShareData(shareData);
            });
        }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
    .reocrd_item_tr {
        /* margin-top:1.2rem; */
        background:#6bbcff;
        color:#fff;
        display: flex;
    }

    .reocrd_item_tr {

    }
    .reocrd_item {
        display: flex;
        font-size:.3rem;
        line-height: 2em;
        margin: 1em;
    }

    .reocrd_item .num {
        min-width:3em;
        height:3em;
        line-height: 3em;
        padding:0 .5em;
        margin-right:1em;
        background:#008eff;
        text-align: center;
        color:#fff;
        border-radius:50%;
    }

    .reocrd_item .time {
        padding:.5em 0;
    }

    .reocrd_item .place {
        padding:.5em 0;
        margin-left:1em;
        flex:1;
    }
</style>
